import ColorSelection from '@/js/single-guide/components/molecules/ColorSelection/ColorSelection';

export default ColorSelection;
